import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { useParams, useHistory } from 'react-router-dom'
import styles from './styles'
import { getCollection } from 'src/reducers/collection/action'
import { useDispatch } from 'react-redux'
import {
  CollectionHeader,
  PageSelector,
  CollectionPageView,
} from './components'
import LandingPageEditor from 'src/components/landing-page/landing-page-editor'
import { CircularProgress } from '@material-ui/core'
import { useSelector } from 'react-redux'
const Collection = props => {
  const { classes } = props
  const { id, page, subPage } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const collection = useSelector(state => state.collection.collection)
  useEffect(() => {
    dispatch(
      getCollection(id, () => {
        setLoading(false)
      }),
    )
    if (page == undefined) {
      history.push(`/collection/${id}/mini-courses`)
    }
  }, [id])
  return (
    <div className={subPage === 'editor' ? classes.editor : classes.root}>
      {loading ? (
        <CircularProgress />
      ) : subPage !== 'editor' ? (
        <div className={classes.contentWrapper}>
          <CollectionHeader />
          <PageSelector />
          <CollectionPageView />
        </div>
      ) : (
        <LandingPageEditor />
      )}
    </div>
  )
}

export default withStyles(styles)(Collection)
